import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';

import Estimation from './components/estimation';

const styles = theme => ({
  card: {
    width: '90%',
    maxWidth: '650px',
    overflow: 'visible',
    marginBottom:'20px'

  },
});

const Index = ({classes}) => (
	<Grid
	  container
	  direction="row"
	  justify="center"
	  alignItems="center"
	>
  	<Card className = {classes.card}>
  		<Estimation />
  	</Card>
	</Grid>
);

Index.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Index);